import React, {Component} from "react";
import {Grid, Row, Col, Form, FormGroup, FormControl, InputGroup, Button} from "react-bootstrap";
import {Route} from "react-router-dom";
import Hr from '../components/Hr';
import FA from '../components/FontAwesome';

function randomPlaceholder() {
    const list = [
        'Sim sala bim!',
        'Skriv inn passord',
        'Abrakadabra',
        'Hokus pokus'
    ];
    return list[Math.floor(Math.random() * list.length)];
}

class Password extends Component {
    constructor(props) {
        super(props);
        this.state = {
            placeholder: randomPlaceholder(),
            password: '',
            showContent: false,
            correctPassword: false,
            validationState: null
        }
    }

    handlePasswordChange = (e) => {
        this.setState({password: e.target.value});
    };

    btnClick = (e) => {
        e.preventDefault();
        if (this.state.password === this.props.pw) {
            this.setState({
                correctPassword: true,
                validationState: 'success'
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showContent: true
                    });
                }, 1500);
            });
        } else {
            this.setState({
                validationState: 'error'
            }, () => {
                setTimeout(() => {
                    this.setState({
                        validationState: '',
                        password: '',
                        placeholder: randomPlaceholder()
                    });
                }, 1000);
            });
        }
    };

    getHeader() {
        if (this.state.correctPassword) {
            return (
                <Grid className="title-container">
                    <Row className="show-grid row">
                        <h1><FA name={"unlock"} size={"2x"}/></h1>
                        <p><FA name={"spinner"} spin/> Vennligst vent..</p>
                    </Row>
                </Grid>
            );
        }
        return (
            <Grid className="title-container">
                <Row className="show-grid row">
                    <h1><FA name={"lock-alt"} size={"2x"}/></h1>
                    <p>Denne siden er passordbeskyttet.</p>
                </Row>
            </Grid>
        );
    }

    render() {
        if (this.state.showContent) {
            return this.props.children;
        }
        return (
            <div className="Home text-center">
                {this.getHeader()}
                <Grid className="content-container">
                    <Hr/>
                    <Row className="show-grid row password">
                        <Col xs={12} md={4} mdOffset={4}>
                            <Form inline onSubmit={this.btnClick}>
                                <FormGroup controlId="formValidationSuccess1"
                                           validationState={this.state.validationState} bsSize="large">
                                    <InputGroup>
                                        <FormControl type="password" placeholder={this.state.placeholder} autoFocus
                                                     value={this.state.password} onChange={this.handlePasswordChange}/>
                                    </InputGroup>
                                    <Button bsSize="large" onClick={this.btnClick}><FA name={"key"}/></Button>
                                </FormGroup>
                            </Form>
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

export default ({component: C, pw: pwProp}) => {
    return (
        <Route render={props => <Password pw={pwProp}><C/></Password>}/>
    );
};


// WEBPACK FOOTER //
// ./src/components/PasswordRoute.js